import { formatNumber } from "accounting"

import { formatCurrency } from "../../../Utils/utils"

// The four headline tabs above the trend chart, read off the kpis/ answer, in the shape the shared
// KpiTab draws. A tab's `key` is the trend endpoint's `metric`, so selecting a tab is what the
// chart asks for. `comparison` is the same figure over the comparison window, present only while
// a comparison is on. `totalLabel` heads the figure in the tooltip, `Rate` for a percentage
// (RCA-5-07).
export const buildKpiTabs = (kpis, t) => {
  const summary = kpis?.summary
  if (!summary) return []

  const compared = kpis?.comparison_summary
  const comparisonLabel = kpis?.comparison_period?.label

  // Incognito hides every figure on the page, counts and rates included.
  const hidden = { secondaryPrivate: true, comparisonPrivate: true }

  return [
    {
      key: "lookups",
      label: t("Bank inquiries"),
      value: summary.lookups_count,
      comparison: compared?.lookups_count,
      comparisonLabel,
      tooltip: "Lookups served to issuing banks for your descriptors in the selected window.",
      secondary: t("_count_ with no order match", {
        count: formatNumber(summary.unmatched_count)
      })
    },
    {
      key: "fees",
      label: t("Lookup volume"),
      value: summary.fees_amount,
      comparison: compared?.fees_amount,
      comparisonLabel,
      prefix: "$",
      tooltip:
        "Charged per lookup by channel: $0.50 banking app, $5.00 call center, $0.50 Mastercom. Every recorded lookup is billable, matched or not.",
      secondary: t("across _count_ lookups", { count: formatNumber(summary.lookups_count) })
    },
    {
      key: "match_rate",
      label: t("Match rate"),
      value: summary.match_rate,
      decimals: 1,
      totalLabel: "Rate",
      comparison: compared?.match_rate,
      comparisonLabel,
      suffix: "%",
      tooltip: "Inquiries answered with an order match, over all inquiries received.",
      secondary: t("_matched_ matched of _count_ inquiries", {
        matched: formatNumber(summary.matched_count),
        count: formatNumber(summary.lookups_count)
      })
    },
    {
      key: "avg_amount",
      label: t("Average amount"),
      value: summary.avg_amount,
      comparison: compared?.avg_amount,
      comparisonLabel,
      prefix: "$",
      // An average is a level: the chart's points and its channel rows are each their own average,
      // so neither adds up to this figure.
      tooltip: "Average amount of the purchases banks asked about. Counted across all lookups.",
      secondary: t("_amount_ total order value", {
        amount: formatCurrency(summary.order_amount ?? 0, true)
      })
    }
  ].map((tab) => ({ ...tab, ...hidden }))
}
